module.exports = __webpack_public_path__ + "img/ch14_04_田埂拍照.dfd083c9.jpg";